/*
 * @Author: dali
 * @Date: 2022-08-29 09:53:21
 * @LastEditors: dali
 * @LastEditTime: 2022-09-26 16:42:33
 * @FilePath: \gerlun-react-website\src\index.js
 * @Description:
 */
import React from 'react'

import ReactDom from 'react-dom'

import { HashRouter } from 'react-router-dom'

import App from './App'

import { Provider } from 'react-redux'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'

import store from './store'

// AndDesign 样式
import 'antd/dist/antd.css'

// 全局与重置样式
import './common/style/frame.scss'

import '@/https/interceptor.js'

const Apps = (
  <ConfigProvider locale={zhCN}>
    <Provider store={store}>
      <HashRouter>
        <App />
      </HashRouter>
    </Provider>
  </ConfigProvider>
)

ReactDom.render(Apps, document.getElementById('root'))
